import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { Button, RSelect } from "../Component";

import employeeService from "../../services/employeeService";
import { useBeManualFetcher } from "../../hooks/useBeManualFetcher";
import EventEmitter, { EVENT_TOPICS } from "../../utilities/eventUtils";
import {
  EMPLOYEE_STATUSES,
  EMPLOYEE_STATUSES_READABLE,
} from "../../utilities/constants";

const statusOptions = Object.values(EMPLOYEE_STATUSES).map((value) => ({
  value,
  label: EMPLOYEE_STATUSES_READABLE[value],
}));

const EmployeeStatusModal = ({ isOpen, onClose, employee }) => {
  const [onFetch, isLoading] = useBeManualFetcher();

  const [status, setStatus] = useState(employee?.status ?? "");
  const [statusReason, setStatusReason] = useState(
    employee?.statusReason ?? ""
  );

  // Har safar ochilganda hodimning joriy holatidan boshlanadi.
  useEffect(() => {
    if (!isOpen) return;
    setStatus(employee?.status ?? "");
    setStatusReason(employee?.statusReason ?? "");
  }, [isOpen, employee]);

  const isOther = status === EMPLOYEE_STATUSES.OTHER;
  const canSubmit = Boolean(status) && (!isOther || statusReason.trim());

  const selectedOption = useMemo(
    () => statusOptions.find((option) => option.value === status) ?? null,
    [status]
  );

  const handleSubmit = () => {
    if (!canSubmit) return;

    onFetch({
      action: () =>
        employeeService.changeEmployeeStatus(employee.id, {
          status,
          statusReason,
        }),
      onLoad: (response) => {
        EventEmitter.emit(EVENT_TOPICS.ON_EMPLOYEE_STATUS_UPDATED, {
          id: employee.id,
          // Javob bo'sh kelsa ham jadval yangilansin.
          status: response?.status ?? status,
          statusReason:
            response?.statusReason ?? (isOther ? statusReason.trim() : null),
        });
        onClose();
      },
      successMessage: "Employee status updated",
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader
        toggle={onClose}
        close={<Button className="close" onClick={onClose} iconName="cross" />}
      >
        Change status
        {employee && (
          <div className="form-note mt-1">
            {employee.firstName} {employee.lastName}
          </div>
        )}
      </ModalHeader>
      <ModalBody>
        <div className="form-group">
          <label className="form-label">Status</label>
          <RSelect
            options={statusOptions}
            value={selectedOption}
            onChange={(option) => setStatus(option?.value ?? "")}
            placeholder="Select status"
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
          />
        </div>

        {isOther && (
          <div className="form-group">
            <label className="form-label">Reason *</label>
            <textarea
              className="form-control"
              rows={3}
              placeholder="Statusni izohlang"
              value={statusReason}
              onChange={(e) => setStatusReason(e.target.value)}
              autoFocus
            />
          </div>
        )}

      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <Button
          color="white border-light"
          onClick={onClose}
          title="Cancel"
        />
        <Button
          color="primary"
          onClick={handleSubmit}
          title="Save"
          iconName="check"
          disabled={!canSubmit}
          isLoading={isLoading}
        />
      </ModalFooter>
    </Modal>
  );
};

export default EmployeeStatusModal;
